import(/* webpackMode: "eager" */ "/app/app/[locale]/error.tsx");
